import { highlightingFor } from "@codemirror/language";
import { Decoration } from "@uiw/react-codemirror";
import { getImageSize } from "@/04-features/edit-image";
import { markdownSourceMarkerTag } from "../../../../themes";
import { isSelectionInside } from "../../util/isSelectionInside";
import { MarkdownMarkerWidget } from "./MarkdownMarkerWidget";
import { markerRules } from "./markerRules";
const getMarkerContext = (node) => {
    const rule = markerRules[node.name];
    const owner = node.node.parent;
    if (!rule || !owner || !rule.ownerNames.includes(owner.name)) {
        return null;
    }
    return { owner, rule };
};
const getHighlightClass = (view, tag) => {
    var _a;
    return (_a = highlightingFor(view.state, [tag])) !== null && _a !== void 0 ? _a : "";
};
const getMarkerReplacement = (view, node, replacementResolver) => {
    if (!replacementResolver)
        return Decoration.replace({});
    const sourceMarker = view.state.doc.sliceString(node.from, node.to);
    const widgetText = replacementResolver(sourceMarker);
    const className = getHighlightClass(view, markdownSourceMarkerTag);
    return Decoration.replace({
        widget: new MarkdownMarkerWidget(widgetText, className)
    });
};
const getMarkerEnd = (view, node, consumesSeparator = false) => {
    if (consumesSeparator
        && /^[ \t]$/.test(view.state.doc.sliceString(node.to, node.to + 1))) {
        return node.to + 1;
    }
    return node.to;
};
export const getMarkerDecorations = (view, node) => {
    var _a, _b;
    const marker = getMarkerContext(node);
    if (!marker || node.from >= node.to)
        return { decorations: [] };
    const ownerTo = marker.owner.name === "Image"
        ? (_b = (_a = getImageSize(view.state, marker.owner.to)) === null || _a === void 0 ? void 0 : _a.to) !== null && _b !== void 0 ? _b : marker.owner.to
        : marker.owner.to;
    const isOwnerActive = isSelectionInside(view, {
        from: marker.owner.from,
        to: ownerTo
    });
    if (!isOwnerActive) {
        return {
            decorations: [
                getMarkerReplacement(view, node, marker.rule.replacementResolver).range(node.from, getMarkerEnd(view, node, marker.rule.consumesSeparator))
            ]
        };
    }
    if (!marker.rule.isSourceMarker) {
        return { decorations: [] };
    }
    return {
        decorations: [
            Decoration.mark({
                class: getHighlightClass(view, markdownSourceMarkerTag),
            }).range(node.from, node.to)
        ]
    };
};
